import React, { useState } from 'react';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import {
  ErrorBoundary,
  ProtectedRoutes,
  RefreshTokenPopup,
  WithConnectionStatus,
} from 'app/components/index';
import { NotFound } from 'app/components/index';
import jwt_decode from 'jwt-decode';
import Cookies from 'universal-cookie';
import Layout from './layout';
import { LoginQR } from './pages';
import {
  NotificationList as NotificationList_V2,
  Dashboard_V2,
  Privacy as PrivacyV2,
  Board as BoardV2,
  Compliance as ComplianceV2,
  Identity_V2,
  Users as User_V2,
  GapAnalysis,
  TOSAuth,
  AddUser as AddUser_V2,
  Settings as Settings_V2,
} from './pages';
import GapAnalysisTOS from './pages/TOS/GapAnalysisTOS';
import { routes } from './routes';
import Documentation from './pages/insights/documentation';
import GlobalAlert from './components/GlobalAlert/GlobalAlert';
import Organisation from './pages/organisation';
import OrgSelect from './pages/orgSelection';
import { fetchAccountSettings } from './utils';

const App = () => {
  const [open, setOpen] = useState(false);

  const location = window.location.pathname;
  const language = window.navigator.language;
  const cookies = new Cookies();
  const cookie = cookies.get('nic-portal') || cookies.get('nic-tos');
  const currentPageLang = JSON.parse(localStorage.getItem('lang'));

  useEffect(() => {
    if (!localStorage.getItem('lang')) {
      if (language === 'en') {
        localStorage.setItem('lang', JSON.stringify('en'));
      } else if (language === 'sv') {
        localStorage.setItem('lang', JSON.stringify('sv'));
      } else if (language !== 'sv' && language !== 'en') {
        localStorage.setItem('lang', JSON.stringify('en'));
      }
    }
  }, [currentPageLang]);

  useEffect(() => {
    if(cookie){
      fetchAccountSettings();
    }
  }, [cookie])
 
  useEffect(() => {
    if (cookie) {
      const intervalId = setInterval(() => {
        const currentTime = new Date();
        const decodedToken = jwt_decode(cookie);
        const expirationTime = decodedToken.exp * 1000;
        const expiry = new Date(expirationTime);
        const remainingTime = Math.floor((expiry.getTime() - currentTime.getTime()) / (1000 * 60));

        const time = (remainingTime - 3) * 60000;
        if (time <= 60000) {
          setOpen(true);
        }
      }, 100);

      return () => clearInterval(intervalId);
    }
  }, [location]);

  return (
    <ErrorBoundary>
      {cookie && <RefreshTokenPopup open={open} setOpen={setOpen} />}
      <BrowserRouter>
        <GlobalAlert />
        <Routes>
          <Route path={routes.LOGIN} element={<LoginQR />} />
          <Route path={routes.TOS} element={<TOSAuth />} />
          <Route
            element={
              <ProtectedRoutes nicRoutes={<Layout />} tosRoutes={<Outlet />}></ProtectedRoutes>
            }
          >
            <Route path={routes.TOSGAP} element={<GapAnalysisTOS />} />

            <Route path={routes.ORGSELECT} element={<OrgSelect />} />
            <Route path={routes.HOME} element={<Dashboard_V2 />} />
            <Route path={routes.USERS} element={<User_V2 />} />
            <Route path={routes.GAP} element={<GapAnalysis />} />
            <Route path={routes.MESSAGES} element={<NotificationList_V2 />} />
            <Route path={routes.SETTINGS} element={<Settings_V2 />} />
            <Route path={routes.IDENTITY} element={<Identity_V2 />} />
            <Route path={routes.ADDUSER} element={<AddUser_V2 />} />
            <Route path={routes.EDITUSER} element={<AddUser_V2 />} />
            <Route path={routes.PRIVACY} element={<PrivacyV2 />} />
            <Route path={routes.BOARD} element={<BoardV2 />} />
            <Route path={routes.COMPLIANCE} element={<ComplianceV2 />} />
            <Route path={routes.DOCUMENTATION} element={<Documentation />} />
            <Route path={routes.ORGANISATION} element={<Organisation />} />
          </Route>
          <Route path='*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default WithConnectionStatus(App);
